import React from "react";
import BannerForHome from "../components/BannerForHome";
import ServicesSectionForHome from "../components/HomePage/ServicesSectionForHome";
import PricingSectionForHome from "../components/HomePage/PricingSectionForHome";
import TestimonialSectionForHome from "../components/HomePage/TestimonialSectionForHome";
import ContactUs from "./ContactUs";
import ServicesFetureSectionForHome from "../components/HomePage/ServicesFetureSectionForHome";
import VideoSectionForHome from "../components/HomePage/VideoSectionForHome";
import StepSectionForHome from "../components/HomePage/StepSectionForHome";
import FAQSectionForHome from "../components/HomePage/FAQSectionForHome";
import AboutSectionForHome from "../components/HomePage/AboutSectionForHome";
import CounterSection from "../components/CounterSection";
import CounterSectionForHome from "../components/CounterSectionForHome";





const Home = () => {


  return (
    <>


      <BannerForHome></BannerForHome>
      <ServicesSectionForHome></ServicesSectionForHome>
      <VideoSectionForHome></VideoSectionForHome>
      <ServicesFetureSectionForHome></ServicesFetureSectionForHome>
      <CounterSectionForHome></CounterSectionForHome>
      <PricingSectionForHome></PricingSectionForHome>
      <FAQSectionForHome></FAQSectionForHome>
      <ContactUs></ContactUs>


    </>
  );
};

export default Home;
